import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

function Copyright(props: any) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            sx={{ lineHeight: 1, fontSize: '0.75rem', p: 0, m: 0 }}
            {...props}
        >
            {'Copyright © '}
            <Link color="inherit" href="https://www.exponent.com">
                Exponent, Inc.
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                height: 28,
                minHeight: 28,
                py: 0,
                px: 2,
                mt: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                backgroundColor: (theme) =>
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[200]
                        : theme.palette.grey[800],
                borderTop: (theme) => `1px solid ${theme.palette.mode === 'light'
                    ? theme.palette.grey[300]
                    : theme.palette.grey[900]
                }`
            }}
        >
            <Copyright />
        </Box>
    );
}
